import { ConfigurableColumns } from 'app/components/BasicTable/ConfigurableColumns';
import { ExportImportApi } from './Api';
import { ImportAdditionalData, ImportData, TemplateColumns } from './Types';

const Api = new ExportImportApi();
export const ExportImportActions = {
  Export: (url: string, data?: any) => {
    return Api.export(url, data);
  },
  Import: (url: string, file, data?: ImportData) => {
    return Api.import(url, file, data);
  },
  TemplateColumns: (
    screenId: number,
    Iad: ImportAdditionalData = ImportAdditionalData.none,
  ) => {
    return Api.TemplateColumns<TemplateColumns>(screenId, Iad);
  },
  ConfigurableColumns: (
    url: string,
    listId: number,
    configurableType: number,
  ) => {
    return Api.ConfigurableColumns<ConfigurableColumns>(
      url,
      listId,
      configurableType,
    );
  },
  ImportTemplate: (
    screenId: number,
    ext: string,
    Iad: ImportAdditionalData = ImportAdditionalData.none,
  ) => {
    return Api.ImportTemplate(screenId, ext, Iad);
  },
  ExportForImport: (
    ScreenId: number,
    Ids: number[],
    Iad: ImportAdditionalData = ImportAdditionalData.none,
  ) => {
    return Api.ExportForImport(ScreenId, Ids, Iad);
  },
  ImportImages: (files: File[], ScreenId: number) => {
    return Api.importImages(files, ScreenId);
  },
};
